import React from 'react';
import { Link } from 'react-router-dom';
import { AvatarWrapper } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';
import { ProfileResumeBody, ProfileResume, ProfileResumeName, ProfileResumeEmail } from '@/components/custom/profile';

const UserInfo = ({ user, viewEmail, disableLink = false, props }) => {
  const avatarImage = user?.image?.url;
  const avatarImageMemo = React.useMemo(() => avatarImage, [avatarImage]);

  const avatar = (
    <AvatarWrapper
      src={avatarImageMemo}
      text={user?.name}
      className="size-9"
    />
  );

  return (
    <ProfileResume {...props}>
      {disableLink ? avatar : <Link to={`/usuario/metricas/${user?.id}`}>{avatar}</Link>}

      <ProfileResumeBody>
        <ProfileResumeName title={user?.name}>{disableLink ? user?.name : <Link to={`/usuario/metricas/${user?.id}`}>{user?.name}</Link>}</ProfileResumeName>

        {user?.profiles?.[0] && !viewEmail && (
          <Badge
            variant="neutral-lightest"
            size="xs"
            className="font-light"
            title={user?.profiles[0]?.name ?? user?.profiles?.[0]}
          >
            {user?.profiles[0]?.name ?? user?.profiles?.[0]}
          </Badge>
        )}

        {user?.['profile-names']?.[0] && (
          <Badge
            variant="neutral-lightest"
            size="xs"
            className="font-light"
            title={user?.['profile-names']?.[0]}
          >
            {user?.['profile-names']?.[0]}
          </Badge>
        )}

        {viewEmail && <ProfileResumeEmail title={user?.email}>{user?.email}</ProfileResumeEmail>}
      </ProfileResumeBody>
    </ProfileResume>
  );
};
UserInfo.displayName = 'UserInfo';

export { UserInfo };
